/**
 * The signed-in consumer's self-funding access and when it ends (or ended). Advisors and wizards
 * viewing a consumer have no subscription in their session; `isConsumerSession` lets screens treat
 * them as viewers rather than buyers.
 */
import { useSelector } from 'react-redux';
import { selectSession } from '@/model';
import { useIsConsumerSession } from '@/hooks/use-app-mode';
import { getSelfFundAccess, type SelfFundAccess } from '../lib/self-fund-access';

export function useSelfFundAccess(): {
  access: SelfFundAccess;
  endsAt: string | null;
  isConsumerSession: boolean;
} {
  const { clientStripe } = useSelector(selectSession);
  const isConsumerSession = useIsConsumerSession();

  return {
    access: getSelfFundAccess(clientStripe),
    endsAt: clientStripe?.currentPeriodEnd ?? null,
    isConsumerSession,
  };
}
